/**
 * `placeholderData` for a query keyed `[name, sourceId, ...]`: the last answer stays on screen while
 * the next one loads, but only for the same playlist.
 *
 * Plain `keepPreviousData` also kept it across a playlist switch. On 2026-10-20 the switch to the
 * store reviewers' playlist showed the previous playlist's films for a moment, and Home's banner
 * took one of them and kept it as that playlist's banner for every later start.
 */
export function keepWithinSource<T>(sourceId: string) {
  return (previous: T | undefined, previousQuery: { queryKey: readonly unknown[] } | undefined): T | undefined =>
    previousQuery?.queryKey[1] === sourceId ? previous : undefined;
}
